export class TaxPayer {
    public LegalCenter:string;
    public  FoundationDate: string;
    public Chamber:string;
    public ChamberRegNo: string;
    public TradeRegistryOffice: string;
    public TradeRegistryNumber: string;
    public MersisNo: string;
    public TaxOffice:string;
    public TapdkNo: string;
    public ESignatureExpDate: string;
    public TaxOfficeName: string;
}



